var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 2.66674C5.05464 2.66674 2.66683 5.05455 2.66683 8.00007C2.66683 10.9456 5.05464 13.3334 8.00016 13.3334C10.9457 13.3334 13.3335 10.9456 13.3335 8.00007C13.3335 5.05455 10.9457 2.66674 8.00016 2.66674ZM1.3335 8.00007C1.3335 4.31817 4.31826 1.3334 8.00016 1.3334C11.6821 1.3334 14.6668 4.31817 14.6668 8.00007C14.6668 11.682 11.6821 14.6667 8.00016 14.6667C4.31826 14.6667 1.3335 11.682 1.3335 8.00007Z",
    fill: "#F27E2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 9.3334C7.63197 9.3334 7.3335 9.03493 7.3335 8.66674L7.3335 4.66674C7.3335 4.29855 7.63197 4.00007 8.00016 4.00007C8.36835 4.00007 8.66683 4.29855 8.66683 4.66674L8.66683 8.66674C8.66683 9.03493 8.36835 9.3334 8.00016 9.3334Z",
    fill: "#F27E2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 11.0001C7.00016 10.4478 7.44788 10.0001 8.00016 10.0001C8.55245 10.0001 9.00016 10.4478 9.00016 11.0001C9.00016 11.5524 8.55245 12.0001 8.00016 12.0001C7.44788 12.0001 7.00016 11.5524 7.00016 11.0001Z",
    fill: "#F27E2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.b03c02c134bb64137e2935bee1001bab.svg";
export { ForwardRef as ReactComponent };